import { useFeatureFlagExposure } from 'featureFlags';

/**
 * Records the 3X withhold exposure (ops.multi-run-withhold-3x) for the
 * initiator, whose offer the flag decides. UserActions renders it beside the
 * offer row, so it mounts only when the player can see that choice, never
 * while a rejoin or another control holds the action slot.
 */
const WithholdExposure = ({ isInitiator }: { isInitiator: boolean }) => {
  useFeatureFlagExposure('multiRunWithhold3x', 'multi_run_vote', isInitiator);
  return null;
};

export default WithholdExposure;
